export default __webpack_public_path__ + "static/media/capitallux-cropped.badaf2ff.jpg";